<template>
  <page
    :custom-style="{
      height: '100vh',
      backgroundColor: '#fff'
    }"
  >
    <!-- <head-nav :no-border="true">
      <span
        slot="left"
        class="back mc-app-normal mcicon-mc-icon-arrowleft1"
        @click="goBackPage"
      ></span>
      <p slot="title" class="head-title">下载检验合格证</p>
    </head-nav> -->
    <page
      :custom-style="{
        background: '#f5f5f5',
        bottom: '0',
        top: statusBarHeight
      }"
    >
      <div class="content">
        <p class="title">
          {{ tips || '当前页面仅展示已上传检验合格证的商品' }}
        </p>
        <ul class="select-list">
          <li v-for="item in list.order_item" :key="item.item_id" class="item">
            <p class="title">{{ item.ssu_name }}</p>
            <ul class="img-wrapper">
              <li
                v-for="(img, index) in item.qcs"
                :key="img"
                class="item-img"
                @click="handleClick(img, item.qcs, index)"
              >
                <img :src="img" />
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </page>
  </page>
</template>

<script>
import { miniProgramEnv } from '@/defines/environment'
// import { getPlatform } from '@/defines/environment/getters/get_platform'
import { navBar } from '@/utils/native_interactions/native_bar'
import { API } from '@/api'
import Url from '@mc/mc-utils/js/url/url'
// import { $_platform_ios } from 'app/utils/global' // eslint-disable-line camelcase
// import wxUtil from 'app/utils/wxjssdk.js'
// import appCommonInfo from 'app/utils/bridge/appCommonInfo.js'
// const appInfo = appCommonInfo.AppCommonInfo._ENV_.appInfo

export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      navBar.setTitle({
        text: '下载检验合格证'
      })
    })
  },
  data() {
    return {
      list: {},
      tips: '',
      companyName: ''
    }
  },
  created() {
    this.getCompany()
    this.getqcbyorderids()
  },
  methods: {
    handleClick(current, imgArr, index) {
      this.$track(this.$trackMap.quarantine.btnPicture)
      const imgs = imgArr.map(img => {
        return img
      })
      if (miniProgramEnv.isMiniProgram) {
        // eslint-disable-line camelcase
        window.wx.ready(() => {
          window.wx.previewImage({
            current: current, // 当前显示图片的http链接
            urls: imgs // 需要预览的图片http链接列表
          })
        })
      } else {
        this.$Slide.open({
          imgArr: imgs,
          activeIndex: index,
          isSaveImg: true,
          commonWaterMark: false
        })
      }
    },
    async getqcbyorderids() {
      this.$Loading()
      const url = new Url(window.location.href)
      const query = url.parseQuerystring()
      const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}
      const id = query.id || hashQuery.id || ''
      const orderIds = query.orderIds || hashQuery.orderIds || ''
      // eslint-disable-next-line camelcase
      const selected_company_id =
        query.selected_company_id || hashQuery.selected_company_id || ''
      const inspectTypeList = this.$route?.query?.inspectType || ''
      const params = {
        order_id: this.$route.query.id || id,
        status: 1,
        deliveryTime: this.$route.query.c_t,
        inspectTypeList,
        selected_company_id,
        orderIds
      }
      try {
        const res = await API.quarantine.getqcbyorderids(params)
        this.list = res
        this.tips = res?.tips || '当前页面仅展示已上传检验合格证的商品'
      } catch (error) {}
      this.$Loading.hide()
    },
    async getCompany() {
      try {
        const res = await API.account.getCompany()
        this.companyName = res.company_name
      } catch (error) {}
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  .title {
    padding: 0.2rem 0 0.16rem 0.3rem;

    font-size: 0.24rem;
    color: #666666;
  }
  .select-list {
    .item {
      margin-bottom: 0.02rem;

      background: #fff;
      .title {
        color: #333;
      }
      .img-wrapper {
        padding: 0 0 0.24rem 0.3rem;

        white-space: nowrap;
        overflow-y: auto;
        .item-img {
          display: inline-block;

          width: 1.8rem;
          height: 1.8rem;

          margin-right: 0.16rem;

          border-radius: 2px;
          border: 1px solid #ebebeb;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
